module.exports = __webpack_public_path__ + "img/redBallone.b9dcfc13.png";